import { withApp } from "./story";

/** Lifecycle: overview + 3 drill pages (max). Full track linked from overview only. */
export const LIFE_FLOWS = [
  { id: "overview", label: "Overview" },
  { id: "understand", label: "Understand" },
  { id: "decide", label: "Decide" },
  { id: "deliver", label: "Deliver" },
];

export const LIFE_PHASES = {
  understand: {
    label: "Understand",
    summary: "WHY and evidence (5 steps)",
    stepIds: ["why", "evidence_intake", "canonical_evidence", "questionnaire", "passport"],
  },
  decide: {
    label: "Decide",
    summary: "7R, MDR, reassess (7 steps)",
    stepIds: ["7c7s", "dependencies", "7r", "recommendation", "authorization", "mdr", "reassess"],
  },
  deliver: {
    label: "Deliver",
    summary: "Wave, gates, deploy, G8 value (7 steps)",
    stepIds: ["wave", "gates", "deployment", "validation", "hypercare", "success", "value"],
  },
};

export function lifecycleFocusHref(appId, focus) {
  if (!focus || focus === "overview") return withApp("/lifecycle", appId);
  const params = new URLSearchParams({ focus });
  if (appId) params.set("app", appId);
  return `/lifecycle?${params.toString()}`;
}

export function phaseProgress(steps, stepIds) {
  const subset = (steps || []).filter((s) => stepIds.includes(s.id));
  const done = subset.filter((s) => s.state === "done").length;
  return { done, total: subset.length || stepIds.length, steps: subset };
}

export function scopeSteps(steps) {
  return (steps || []).filter((s) => ["tenant", "project", "application"].includes(s.id));
}
